import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdTemplatedPreviewCacheKeys: AllRouteEndpoints[] = [];
export const engagementAppGroupIdTemplatedPreview = "/engagement/:app_group_id/templated_preview";
